import { useCallback, useEffect, useRef, } from 'react';
import fastDeepEqual from 'fast-deep-equal';
import { BaseRequestParams, } from 'admin/src/request/request';
import request from 'admin/src/request/client';
import useDefaultReducer from './useDefaultReducer';

interface UseSessionFetchReturn<TData> {
	data: TData;
	isDataLoading: boolean;
	error: null | Error;
	reFetch: () => Promise<void>;
}
export type ClientRequestParam = string | BaseRequestParams;

export default function useFetch<TResponse = Record<string, unknown>, TViewModel = TResponse>(
	params?: ClientRequestParam,
	config?: {
		mapper?: ( response: TResponse ) => TViewModel;
		initialData?: TViewModel;
	},
): UseSessionFetchReturn<TViewModel> {
	const _config = config ?? {};

	const {
		initialData = {},
		mapper,
	} = _config;
	// const unMountAbortController = useMemo(
	//   () => new AbortController(),
	//   [
	//   ],
	// )
	const paramsRef = useRef( {} as BaseRequestParams, );
	const [
		result,
		dispatch,
	] = useDefaultReducer( {
		data: initialData as TViewModel,
		isDataLoading: true,
		error: null,
	}, );
	const reFetch = useCallback(
		async function reFetchCallBack() {
			// @ts-ignore
			dispatch.update( {
				data: initialData,
				isDataLoading: true,
				error: null,
			}, );

			try {
				let params = paramsRef.current;
				if ( typeof paramsRef.current === 'string' ) {
					params = {
						url: paramsRef.current,
					};
				}
				const response = await request( {
					...params,
					//  signal: unMountAbortController.signal,
				}, );

				let data = await response.json();

				if ( typeof mapper === 'function' ) {
					data = mapper( data, );
				}

				// @ts-ignore
				dispatch.update( {
					data,
					isDataLoading: false,
				}, );
			} catch ( error ) {
				// @ts-ignore
				if ( error.name === 'AbortError' ) {
					return;
				}

				console.log( error, );

				// @ts-ignore
				dispatch.update( {
					isDataLoading: false,
					error,
				}, );
			}
		},
		[
			dispatch,
			mapper,
		],
	);

	result.reFetch = reFetch;

	useEffect(
		() => {
			if ( !params || typeof params !== 'string' && !params?.url ) {
				return;
			}

			if ( fastDeepEqual( paramsRef.current, params, ) ) {
				return;
			}

			// @ts-ignore
			paramsRef.current = params;

			reFetch();
		},
		[
			params,
			reFetch,
		],
	);

	// useEffect(
	//   () => function cleanupUseEffect() {
	//     unMountAbortController.abort()
	//   },
	//   [
	//     unMountAbortController,
	//   ],
	// )

	return result;
}
